import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { Collapse } from "@mui/material"

import "./styles.scss"

export default class Panel extends Component {
  static propTypes = {
    expanded: PropTypes.bool,
    fixed: PropTypes.bool,
    onChange: PropTypes.func,
  }

  constructor(props, ...args) {
    super(props, ...args)

    this.isControlled = props.expanded !== undefined

    if (!this.isControlled) {
      this.state = { expanded: !!props.fixed }
    } else {
      this.state = {}
    }
  }

  render() {
    const { expanded: expandedProp, children, fixed } = this.props
    const { expanded: expandedState } = this.state
    const expanded = this.isControlled ? expandedProp : expandedState

    return <div className={classnames("components_material_panel", { expanded, expandable: !fixed, fixed })}>
      {!fixed ? <Collapse collapsedSize={48} in={expanded}>
        {children}
      </Collapse>
        : children}
    </div>
  }
}
